import React from 'react';
import { Link } from 'react-router-dom';

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
  </svg>
);

const TikTokIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
  </svg>
);

const XIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4l11.733 16h4.267l-11.733 -16z" />
    <path d="M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772" />
  </svg>
);

const Footer: React.FC = () => (
  <footer className="site-footer">
    <div className="footer-inner">
      <div className="footer-copy">
        &copy; 2026 Colleen Lavin
      </div>

      <nav className="footer-nav">
        <Link to="/">Home</Link>
        <Link to="/shows">Shows</Link>
        <Link to="/press">Press Kit</Link>
        <Link to="/contact">Contact</Link>
      </nav>

      <div className="footer-socials">
        <a
          className="social"
          href="https://instagram.com/colleenjokes"
          target="_blank"
          rel="noreferrer"
          aria-label="Instagram"
        >
          <InstagramIcon />
        </a>
        <a
          className="social"
          href="https://www.tiktok.com/@colleenjokes"
          target="_blank"
          rel="noreferrer"
          aria-label="TikTok"
        >
          <TikTokIcon />
        </a>
        <a
          className="social"
          href="https://x.com/colleenjokes"
          target="_blank"
          rel="noreferrer"
          aria-label="X (Twitter)"
        >
          <XIcon />
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
